import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tableReport", "previewReport", "onPreviewReportChange"];
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { SRVTableActionsMenu } from './SRVTableActionsMenu';
import { SingleObjectTableMetricsEditor } from '../../../reportEditors/TableMetricEditor/SingleObjectTableMetricEditor';
import { getEditorSchemasFromConfig } from '../../../reportEditors/common/editorUtils';
import { useEditorComponents } from '../../../reportEditors/common/useEditorComponents';
import { ConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { useContext } from 'react';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SRVSummarizedTableActionsBar(_ref) {
  let {
      tableReport,
      previewReport,
      onPreviewReportChange
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    appUsageTracker
  } = useContext(EnablementTrackingContext);
  const editors = useEditorComponents(tableReport, getEditorSchemasFromConfig(tableReport), [SingleObjectTableMetricsEditor]);
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "end",
    padding: "200",
    children: [editors.map(Editor => /*#__PURE__*/_jsx(Editor, {
      appUsageTracker: appUsageTracker,
      isV2FilterExperience: true,
      onChange: onPreviewReportChange,
      options: {
        readOnly: false
      },
      report: previewReport
    }, Editor.displayName || Editor.name)), /*#__PURE__*/_jsx(SRVTableActionsMenu, Object.assign({
      report: tableReport
    }, props))]
  });
}